import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-light-slider',
  templateUrl: './light-slider.component.html',
  styleUrls: ['./light-slider.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class LightSliderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/features/light-slider/light-slider.component.ts